import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import theme from '@ecp/common/src/style/theme/default';
import { FlexBoxCenter, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { ReactComponent as IconTriangle } from '@ecp/common/src/assets/icon/icon__triangle.svg';
import styled from 'styled-components';

const RankRealTimeDelta = ({ rankDelta }) => {
  const isUp = useMemo(() => {
    return rankDelta > 0 && rankDelta <= 10;
  }, [rankDelta]);

  return (
    <FlexBoxCenter>
      {rankDelta > 10 && (
        <TextBox
          size={'10px'}
          weight={theme.font.weight.medium}
          color={theme.color.primary}
          title={'순위 단계 신규 진입'}
        >
          NEW
        </TextBox>
      )}
      {isUp && (
      <IconWrapper isUp={isUp}>
        <IconTriangle fill={isUp ? theme.color.primary : theme.color.text.basic} />
      </IconWrapper>
      )}
      {rankDelta === 0 && (
        <FlexBoxCenter>
          <HorizontalDivider
            width={'10px'}
            height={'2px'}
            color={theme.color.text.placeholder}
            title={'순위 단계 변경 없음'}
          />
        </FlexBoxCenter>
      )}
      {rankDelta < 0 && (
        <IconWrapper isUp={isUp}>
          <IconTriangle fill={isUp ? theme.color.primary : theme.color.text.basic} />
        </IconWrapper>
      )}
    </FlexBoxCenter>
  );
};

export default RankRealTimeDelta;

const IconWrapper = styled.div`
  transform: ${({ isUp }) => (isUp ? 'rotate(0)' : 'rotate(180deg)')};
`;

RankRealTimeDelta.propTypes = {
  rankDelta: PropTypes.number,
};
